import React, { useEffect, useState, useRef } from "react";
import { BsThreeDotsVertical } from "react-icons/bs";
import { CiSearch } from "react-icons/ci";
import Outlet from "../Outlet";
import Breadcrumb from "../Breadcrumb";
import "../../assets/Css/Dashboard.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const UserManagement = () => {
  const [selectedRange, setSelectedRange] = useState("All");
  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [menuOpen, setMenuOpen] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalUsers, setTotalUsers] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const navigate = useNavigate();

  const menuRef = useRef(null);

  const fetchUsers = async () => {
    try {
      const token = localStorage.getItem("adminToken"); // token stored after login
      const response = await axios.get(
        "https://network.rentel.in/admin/users",
        {
          params: {
            limit: 20,
            page: currentPage,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setUsers(response.data.users || []);
      setTotalUsers(response.data.total); // Adjust key based on actual API response
      setTotalPages(response.data.totalPages); // Adjust key based on actual API response
    } catch (error) {
      // console.error("Error fetching users:", error);
    }
  };
  // ✅ Fetch users from API
  useEffect(() => {
    fetchUsers();
  }, [currentPage]);

  const searchUsers = async (value) => {

    try {

      console.log("Searching for:", value);
      const token = localStorage.getItem("adminToken"); // token stored after login
      const response = await axios.get(
        "https://network.rentel.in/admin/users",
        {
          params: {
            search: value,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setUsers(response.data.users || []);
      setTotalUsers(response.data.total); // Adjust key based on actual API response
      setTotalPages(response.data.totalPages);
      setCurrentPage(1); // Adjust key based on actual API response
    } catch (error) {
      // console.error("Error fetching users:", error);
    }
  }
  // Close menu on outside click
  useEffect(() => {
    const handler = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(null);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const handleViewClick = (user) => {
    navigate("/ActionView", {
      state: {
        user: user,
      },
    });
  };

  const handleToggleBlockUser = async (id, block) => {
    try {
      const token = localStorage.getItem("adminToken");

      await axios.patch(
        `https://network.rentel.in/admin/users/${id}`,
        {
          isActive: !block,
          seen: true,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setUsers((prev) =>
        prev.map((user) =>
          user._id === id ? { ...user, isActive: !block, seen: true } : user
        )
      );

      setMenuOpen(null);
    } catch (error) {
      // console.error(`Error ${block ? "blocking" : "unblocking"} user:`, error);
    }
  };

  const deleteUser = async (userId, hard = false) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this user?"
    );
    if (!confirmDelete) return;

    try {
      const token = localStorage.getItem("adminToken");
      const url = `https://network.rentel.in/admin/users/${userId}?hard=${hard}`;

      const response = await axios.delete(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      // ✅ Remove only that user from list
      setUsers((prevUsers) => prevUsers.filter((user) => user._id !== userId));

      return response.data;
    } catch (error) {
      throw error;
    }
  };

  const filterByDateRange = (users, range) => {
    const now = new Date();
    let startDate, endDate;

    switch (range) {
      case "All":
        return users; // 🔥 Directly return all users

      case "Last Month":
        startDate = new Date(now.getFullYear(), now.getMonth() - 1, 1);
        endDate = new Date(now.getFullYear(), now.getMonth(), 0);
        break;

      case "Last Week":
        startDate = new Date();
        startDate.setDate(startDate.getDate() - 7);
        endDate = now;
        break;

      case "Today":
        startDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        endDate = now;
        break;

      case "Last 6 Months":
        startDate = new Date();
        startDate.setMonth(startDate.getMonth() - 6);
        endDate = now;
        break;

      default:
        return users; // If no matching range, return all
    }

    return users.filter((user) => {
      if (!user.createdAt) return false;

      const userDate = new Date(user.createdAt);
      return userDate >= startDate && userDate <= endDate;
    });
  };


  // Final filtered users (date range + search + not deleted)
  const filteredUsers = filterByDateRange(users, selectedRange).filter((u) =>
    u.isDeleted === false
  );

  /* reset page on search/filter */
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, selectedRange]);



  return (
    <Outlet>
      <div className="dashboard-headera">
        <div className="dashboard-title">
          <h2 className="dashboard-title">Dashboard</h2>
          <select
            className="dashboard-filter"
            value={selectedRange}
            onChange={(e) => setSelectedRange(e.target.value)}
          >
            <option>All</option>
            <option>Last 6 Months</option>
            <option>Last Month</option>
            <option>Last Week</option>
            <option>Today</option>
          </select>
        </div>
        <Breadcrumb />
      </div>

      <div className="user-table-container">
        <div className="user-headered">
          <h2>User Table View</h2>
          <div className="user-controls">
            <CiSearch className="search-icon" />
            <input
              type="text"
              className="search-box"
              placeholder="Search name, number, etc"
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                searchUsers(e.target.value)
              }}
            />
          </div>
        </div>

        <table className="user-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>User</th>
              <th>Phone</th>
              <th>Email</th>
              <th>Status</th>
              <th>Date Joined</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody className="alter-cnt">
            {filteredUsers.map((user) => (
              <tr key={user._id}>
                <td>{user._id}</td>

                <td className="user-cell">
                  {user.avatar ? (
                    <img
                      src={user.avatar}
                      alt={user.name}
                      className="user-avatar"
                    />
                  ) : (
                    <div className="avatar-fallback">
                      {user.name
                        ? user.name
                          .split(" ")
                          .map((n) => n[0])
                          .join("")
                          .toUpperCase()
                        : "U"}
                    </div>
                  )}
                  {user.name}
                </td>

                <td>{"+91 " + user.phoneNumber}</td>
                <td>{user.email}</td>

                <td className={`status ${user.isActive ? "verified" : "blocked"}`}>
                  {user.isActive ? "Verified" : "Blocked"}
                </td>

                <td>
                  {user.createdAt
                    ? new Date(user.createdAt).toLocaleDateString("en-GB")
                    : "N/A"}
                </td>

                <td style={{ position: "relative" }}>
                  <button
                    className="view-btn"
                    onClick={() => handleViewClick(user)}
                  >
                    View
                  </button>

                  <BsThreeDotsVertical
                    className="dots-icon"
                    onClick={() =>
                      setMenuOpen(menuOpen === user._id ? null : user._id)
                    }
                  />

                  {menuOpen === user._id && (
                    <div className="dropdown-menu" ref={menuRef}>
                      <div
                        className="dropdown-item"
                        onClick={() => deleteUser(user._id)}
                      >
                        Remove User
                      </div>

                      {user.isActive === false ? (
                        <div
                          className="dropdown-item"
                          onClick={() =>
                            handleToggleBlockUser(user._id, false)
                          }
                        >
                          Unblock User
                        </div>
                      ) : (
                        <div
                          className="dropdown-item"
                          onClick={() =>
                            handleToggleBlockUser(user._id, true)
                          }
                        >
                          Block User
                        </div>
                      )}
                    </div>
                  )}
                </td>
              </tr>
            ))}
          </tbody>


        </table>
        {/* ================= PAGINATION UI ================= */}
        {totalPages > 0 && (


          <div className="pagination-container">

            <span>
              Showing{" "}
              {(currentPage - 1) * 20 + 1}–
              {Math.min(currentPage * 20, totalUsers)} of{" "}
              {totalUsers}
            </span>

            <div className="pagination-controls">
              <button
                disabled={currentPage === 1}
                onClick={() => setCurrentPage((p) => p - 1)}
              >
                Prev
              </button>

              {Array.from({ length: totalPages }, (_, i) => i + 1).map(
                (page) => (
                  <button
                    key={page}
                    className={page === currentPage ? "active" : ""}
                    onClick={() => setCurrentPage(page)}
                  >
                    {page}
                  </button>
                )
              )}

              <button
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage((p) => p + 1)}
              >
                Next
              </button>
            </div>
          </div>
        )}
      </div>
    </Outlet>
  );
};

export default UserManagement;
